import paytm from '../../../assets/images/finanse/paytm.svg';
import upi from '../../../assets/images/finanse/upi-logo.png';

export const options = [
  { value: 'PAYTM', label: 'finance_blogger_form_system_paytm', image: paytm },
  { value: 'UPI', label: 'finance_blogger_form_system_upi', image: upi },
];
